import {
  Accordian as CXAccordion,
  AccordianItem as CXAccordionItem
} from '@sanlamcx/react-ui-next-accordian';

type Accordion = typeof CXAccordion;
export const Accordion: Accordion = CXAccordion;
export const AccordionItem = CXAccordionItem;
